import { SupportContextProps, SupportProvider } from '@jbhi-fi/components/src/context/SupportProvider';
import React, { ReactNode } from 'react';
import { dataLayerPushEvent } from '../templates/components/pdp/utils/utils';
import { submitTracking } from '@jbhi-fi/components/src/Tracking/utils/shopifyActionTrackingHelper';

const shopifyValues = (): SupportContextProps => ({
  phoneNumber: window.Jbhifi.jbSalesLine || '',
  onChatClick: () => {
    const isCompare = window.location.pathname.includes('/pages/compare');
    if (isCompare) {
      submitTracking({
        event: 'productCompare',
        action: 'chat',
        trackingDescriptor: {
          page: 'comparePage',
        },
        gtm: {},
      });
    } else {
      dataLayerPushEvent('pdp-seenitcheaper-chat', window.gtm.product);
    }
    return window.openChatButtonClick();
  },
  onCallClick: () => {
    const isCompare = window.location.pathname.includes('/pages/compare');
    if (!isCompare) {
      dataLayerPushEvent('pdp-seenitcheaper-call', window.gtm.product);
    }
    window.location.href = `tel:${window.Jbhifi.jbSalesLine}`;
  },
});

export const ShopifySupportProvider = ({ children }: { children: ReactNode }) => {
  return <SupportProvider {...shopifyValues()}>{children}</SupportProvider>;
};
